import { purgeMailCache } from "@/lib/api/cache";
import { purgeMailEmlStorage } from "@/lib/api/storage";
import { purgeMailClientCaches } from "@/lib/cache/purgeMailClientCaches";
import { resetInboxArchiveSession } from "@/lib/storage/inboxArchiveSession";
import { notifyMailStorageUpdated } from "@/lib/storage/mailStorageEvents";

export type MailStoragePurgeResult = {
  removed: number;
  freedBytes: number;
  removedEntries: Array<{ accountId: number; folder: string; uid: number }>;
};

/** Purge archives .eml uniquement (IMAP intact). */
export async function purgeServerMailStorage(params: {
  accountId: number;
  beforeDate?: string;
  folder?: string;
}): Promise<MailStoragePurgeResult> {
  const res = await purgeMailEmlStorage({
    accountId: params.accountId,
    beforeDate: params.beforeDate,
    folder: params.folder,
  });
  if (!res.ok) {
    throw new Error(res.message);
  }
  if (res.data.removed > 0) {
    notifyMailStorageUpdated(params.accountId, params.folder);
  }
  return {
    removed: res.data.removed,
    freedBytes: res.data.freedBytes,
    removedEntries: [],
  };
}

/** Vide DD02 serveur + caches navigateur pour le compte — repartir propre. */
export async function resetAccountDd02Storage(accountId: number): Promise<void> {
  const cacheRes = await purgeMailCache({ accountId });
  if (!cacheRes.ok) {
    throw new Error(cacheRes.message);
  }
  await purgeMailEmlStorage({ accountId, purgeAll: true }).catch(() => undefined);
  await purgeMailClientCaches({ accountId });
  resetInboxArchiveSession(accountId);
  notifyMailStorageUpdated(accountId);
}
